/* ==========================================================================
 *  Initialization range_slider
 * ======================================================================= */

function fn_components_range_slider(){
    if ($('.js-range-slider').length){
        
        $('.js-range-slider').each(function( index ) {
            var inst = $(this);
            var thisRangeBlock = inst.closest('.js-range-slider-block');
            var thisRangeValue = thisRangeBlock.find('.js-range-slider-value');

            var range = inst.ionRangeSlider({
                type: "double",
                // min: 0,
                // max: 10000000,
                // from: 0,
                // step: 1,
                hide_min_max: true,
                hide_from_to: false,
                postfix: ' Milionu'
            });

            range.on("change", function () {
                var $this = $(this),
                    from = $this.data("from");
                thisRangeValue.text(from);
            });
        });


    }
}

